import type { AppRouteObject } from "../routes";
import { RealmRoute } from "./RealmRoutes";

const routes: AppRouteObject[] = [RealmRoute];

export default routes;
